import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import { useCourseContext } from '@ts-core/context/course';

import MessageNotificationsList from '../../components/MessageNotificationsList';

import { Message } from '../../types';
import { useMessages, useMessageActions } from '../../hooks';

const MessagesPage = () => {
  const history = useHistory();
  const { messages, unseen, loading } = useMessages();
  const { onMarkNotificationsAsSeen } = useMessageActions();
  const { course } = useCourseContext();
  const { _id: courseId } = course || {};

  useEffect(() => {
    if (unseen > 0) {
      onMarkNotificationsAsSeen();
    }
  }, [unseen, onMarkNotificationsAsSeen]);

  const onNotificationClick = useCallback(
    (message: Message) => {
      history.push(`/messages/${message.id}`);
    },
    [history]
  );

  const onGoBack = useCallback(() => {
    if (!courseId) {
      history.push('/courses');
    } else {
      history.push(`${courseId}/dashboard`);
    }
  }, [history, courseId]);

  return (
    <Box>
      <BackButton title="Mensajes" subtitle={courseId ? 'Menú principal' : 'Cursos'} onGoBack={onGoBack} />
      <MessageNotificationsList messages={messages} loading={loading} onNotificationClick={onNotificationClick} />
    </Box>
  );
};

export default MessagesPage;
